import type { ConfigurationValidationError } from '@festina/configuration-general-types/configuration'
import { paperStyles } from '@festina-life/ui/libs'
import { Typography } from '@festina-life/ui/structure'
import cx from 'classnames'

import type { ValidationErrorWithLocation } from '../../uiModels/errors/types'
import { isOperationValidationError } from '../../uiModels/types'
import { useRequiredBranchOperationsContext } from '../../workspace/operationsContext'
import { Attribute } from '../attribute/Attribute'
import { ConfigurationBranchStatus } from '../branchNameWithStatus/ConfigurationBranchStatus'
import { LayerIndicator } from '../layerIndicator/LayerIndicator'
import { WorkspaceName } from '../workspaceName/WorkspaceName'

type Props = {
  validationError: ValidationErrorWithLocation<ConfigurationValidationError>
}

export const CriticalError = ({
  validationError: { error, location, layer },
}: Props) => {
  const { workspaceKey, branchKey } = useRequiredBranchOperationsContext()

  return (
    <div
      className={cx(
        'flex flex-col gap-y-1 rounded-lg border-error-500!',
        paperStyles({ isFaded: true, borders: ['all'] }),
      )}
    >
      {/* Indicators in top-right corner */}
      <div
        className={cx(
          'flex justify-between gap-x-2 p-1 rounded-t-lg items-center',
          paperStyles({ isFaded: false, borders: ['top', 'right', 'left'] }),
        )}
      >
        <Typography weight="semibold">
          {isOperationValidationError(error) ? error.operationName : null}
        </Typography>
        <div className="flex items-center gap-x-2">
          {location === 'workspace' && workspaceKey && (
            <WorkspaceName isShowingIcon workspaceKey={workspaceKey} />
          )}
          {location === 'baseBranch' && (
            <ConfigurationBranchStatus branchKey={branchKey} />
          )}
          <Attribute className="shrink-0 text-sm opacity-75">
            <LayerIndicator layer={layer} />
          </Attribute>
        </div>
      </div>
      {/* Error message content */}
      <div className="wrap-break-word p-1">{error.errorMessage}</div>
    </div>
  )
}
